export function generateGeneralLineData(input, xMin = -100, xMax = 100, step = 0.01) {
  const match = input.replace(/\s+/g, '').match(/^([+-]?[\d.]*x)([+-][\d.]*y)([+-][\d.]+)=0$/);
  if (!match) return [];
  const parseCoeff = (str, variable) => {
    const val = str.replace(variable, '');
    if (val === '' || val === '+') return 1;
    if (val === '-') return -1;
    return parseFloat(val);
  };
  const A = parseCoeff(match[1], 'x');
  const B = parseCoeff(match[2], 'y');
  const C = parseFloat(match[3]);
  const x = [], y = [];
  for (let xi = xMin; xi <= xMax; xi += step) {
    const yi = (-A * xi - C) / B;
    if (isFinite(yi)) { x.push(xi); y.push(yi); }
  }
  return [{ x, y }];
}
